import React from 'react'
import { Typography, type TypographyProps, Skeleton, styled } from '@mui/material'
import { GenericLoader } from '../GenericLoader'
import type { LoadingProps } from '../LoadingProps'

const H6Skeleton = styled(Skeleton)`
    height: 20px;
    margin: 6px 0;
`

interface H6LoadingProps extends LoadingProps, Omit<TypographyProps, 'width'> {}

export const LoaderH6: React.FC<H6LoadingProps> = ({ loading, width, children, align, ...rest }: H6LoadingProps) => {
    let alignSkeleton: 'left' | 'center' | 'right' | undefined
    if (align === 'left' || align === 'center' || align === 'right') {
        alignSkeleton = align
    }

    return (
        <GenericLoader
            loading={loading}
            SkeletonComponent={H6Skeleton}
            skeletonProps={{ width }}
            alignSkeleton={alignSkeleton}
        >
            <Typography {...rest} align={align} variant="h6">
                {children}
            </Typography>
        </GenericLoader>
    )
}

export default LoaderH6
